<app-alert
  [message]="alertMessage"
  [show]="showAlert"
  [showCancel]="showCancel"
  [showConfirm]="showConfirm"
  (closed)="showAlert = false"
  (confirmed)="onAlertClosed(true)"
>
</app-alert>

<mat-toolbar class="topbar d-flex position-relative">
  @if (showBreadcrumb) {
    <div class="topbar__breadcrumb">
      <app-breadcrumb></app-breadcrumb>
    </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <div class="topbar__actions">
    @if (tenantType === 'Tomador') {
      <button
        mat-flat-button
        color="accent"
        class="cardWithShadow topbar__primary-action"
        (click)="openDialog()"
      >
        <div class="d-flex align-items-center">
          <i-tabler
            name="plus"
            class="icon-24 d-flex m-r-8 topbar__primary-icon"
          ></i-tabler>
          <span>Solicitar Serviço</span>
        </div>
      </button>
    }
    <!-- --------------------------------------------------------------- -->
    <!-- Notification Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-mini-fab
      color="inherit"
      [matMenuTriggerFor]="notificationmenu"
      (menuOpened)="menuOpened()"
      aria-label="Notifications"
      class="d-flex justify-content-center"
    >
      <mat-icon
        class="notification-badge"
        [matBadge]="unreadNotificationsBadge"
        matBadgeColor="accent"
        [matBadgeHidden]="unreadNotifications === 0"
        aria-hidden="false"
        [attr.aria-label]="unreadNotificationsLabel"
        >notifications_none</mat-icon
      >
    </button>
    @if (tenantType === 'Tomador') {
      <button
        mat-mini-fab
        color="inherit"
        type="button"
        class="d-flex justify-content-center topbar__help-trigger"
        aria-label="Ajuda"
        matTooltip="Ajuda"
        [matMenuTriggerFor]="helpmenu"
      >
        <mat-icon aria-hidden="true">help_outline</mat-icon>
      </button>
      <mat-menu
        #helpmenu="matMenu"
        class="profinders-help-menu"
        xPosition="before"
      >
        <a
          mat-menu-item
          class="profinders-help-menu__link"
          [href]="helpCenterUrl"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Central de Ajuda (abre em nova aba)"
        >
          <span class="profinders-help-menu__content">
            <span class="profinders-help-menu__icon" aria-hidden="true">
              <i-tabler name="help-circle" class="icon-24 d-flex"></i-tabler>
            </span>
            <span class="profinders-help-menu__copy">
              <span class="profinders-help-menu__title">Central de Ajuda</span>
              <span class="profinders-help-menu__description">
                Manuais e passo a passo para usar a Profinders.
              </span>
            </span>
            <i-tabler
              name="external-link"
              class="icon-18 d-flex profinders-help-menu__external"
              aria-hidden="true"
            ></i-tabler>
          </span>
        </a>
      </mat-menu>
    }
    <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
      <div (click)="$event.stopPropagation()">
        <div class="notification-header">
          <div class="header-content">
            <h3 class="header-title">Notificações</h3>
          </div>

          <div class="navbar-action">
            <!-- <span class="badge-pill" *ngIf="unreadNotifications > 0">
            {{ unreadNotifications }}
            {{ unreadNotifications === 1 ? 'não lida' : 'não lidas' }}
          </span> -->

            <mat-slide-toggle
              [checked]="onlyUnreaded"
              (change)="onToggleChange($event)"
              color="primary"
              matTooltip="{{ slideToggleNotificationMessage() }}"
              matTooltipPosition="above"
            >
            </mat-slide-toggle>

            <button mat-icon-button color="basic" (click)="openNotifications()">
              <i-tabler name="external-link" class="icon-size"></i-tabler>
            </button>
          </div>
        </div>

        <div class="notifications-container" (scroll)="onScroll($event)">
          @for (notification of notifications; track notification.uuid) {
            <button
              mat-menu-item
              class="p-y-12 border-b last:border-b-0"
              (click)="clickNotification(notification)"
              [class.notification-readed]="notification.readed"
            >
              <div class="d-flex align-items-center">
                <span
                  class="flex-shrink-0 text-{{ notification.color }} bg-light-{{
                    notification.color
                  }} rounded-circle icon-48 d-flex align-items-center justify-content-center"
                >
                  <i-tabler
                    name="{{ notification.icon }}"
                    class="icon-20 d-flex"
                  ></i-tabler>
                </span>

                <div class="m-l-16 w-100">
                  <div
                    class="d-flex align-items-center justify-content-between w-100"
                  >
                    <h5 class="f-s-14 f-w-600 m-0 p-t-4 text-truncate">
                      {{ notification.title }}
                    </h5>
                  </div>
                  <span
                    class="d-flex f-s-12 break-word text-truncate-2"
                    style="white-space: normal; line-height: 1.2"
                  >
                    {{ notification.description }}
                  </span>
                  <span
                    class="d-flex f-s-12 m-l-auto justify-content-start text-muted m-t-4"
                  >
                    {{ notification.createdAt | date: 'dd/MM/yyyy - HH:mm' }}
                  </span>
                </div>
              </div>
            </button>
          }
          @if (loading) {
            <div class="loading-spinner p-10 text-center">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          }
        </div>
      </div>
    </mat-menu>

    <button
      mat-fab
      extended
      color="inherit"
      [matMenuTriggerFor]="profilemenu"
      [attr.aria-label]="'Perfil e conta: ' + tenantType"
      class="d-flex justify-content-center profile-btn-dd"
      style="background-color: #dfe1e0"
    >
      <div class="d-flex align-items-center gap-4">
        <img
          src="/assets/images/profile/logo-png.png"
          class="rounded-circle object-cover icon-35 profile-dd"
          width="35"
        />

        <p class="topbar__tenant-label">{{ tenantType }}</p>
        <i
          data-icon="solar:alt-arrow-down-bold"
          class="iconify f-s-8 m-l-8 topbar__profile-chevron"
        ></i>
      </div>
    </button>
  </div>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div (click)="$event.stopPropagation()">
      <div class="p-x-32 p-y-16">
        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            src="/assets/images/profile/logo-png.png"
            class="rounded-circle"
            width="56"
          />
          <div class="m-l-16">
            <h6
              class="f-s-14 f-w-600 m-0 mat-subtitle-1 d-flex align-items-center"
            >
              {{ user.name }}
              <span class="f-s-14 d-block text-success m-l-4">{{
                tenantType
              }}</span>
            </h6>
            <span> {{ user.email }} </span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        @if (getTenants().length > 1) {
          <div
            class="d-flex align-items-center justify-content-center b-b-1 p-b-16"
          >
            <app-toggle-buttons
              [options]="tenantOptions"
              [initialValue]="tenantType"
              (optionChange)="onTenantChange($event)"
              style="width: 100%"
              confirmationNecessary
            >
            </app-toggle-buttons>
          </div>
        }
        <!-- @else {
            <div class="account-container">
              <p>
                Ainda não possui uma conta
                <b>{{ tenantType === 'Prestador' ? 'Tomador' : 'Prestador' }}</b
                >?
              </p>
              <button class="register-button" (click)="createNewTenant()">
                Registre Aqui
              </button>
            </div>
          } -->
      </div>
      <div class="p-x-32 p-b-16">
        @for (profile of userPanel; track profile.title) {
          <a
            *ngIf="isVisible(profile)"
            class="p-8 text-decoration-none d-block text-hover-primary"
            (click)="selected(profile)"
            style="cursor: pointer"
          >
            <div class="d-flex align-items-center">
              <h5
                class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text"
              >
                {{ profile.title }}
              </h5>
              @if (profile.new) {
                <span
                  class="bg-light-error text-error rounded-sm p-x-8 p-y-4 f-w-500 f-s-12 m-l-4"
                  >5</span
                >
              }
            </div>
          </a>
        }
      </div>
      <div class="p-x-32 p-b-16 system-version">
        <span class="system-version__env">Versão: v{{ appVersion }}</span>
        <span class="system-version__env">{{ appEnvironment }}</span>
      </div>
    </div>
  </mat-menu>
</mat-toolbar>
